import { Component, EventEmitter, HostBinding, HostListener, Input, OnInit, Output } from '@angular/core'
import * as lodash from 'lodash'

@Component({
  selector: 'app-rating',
  templateUrl: './rating.component.html',
  styleUrls: ['./rating.component.scss'],
})
export class RatingComponent implements OnInit {
  // 0-5
  stars: number[] = []
  @Input() set rating(v: number) {
    this.rateIndex = v
    this.hoverIndex = v
    const full = Math.floor(v)
    const half = v - full > 0
    const empty = 5 - Math.ceil(v)
    this.stars = [...lodash.times(full).map(() => 1), half ? 0.5 : 0, ...lodash.times(empty).map(() => 0)].slice(0, 5)
  }
  @HostBinding('class.editable')
  @Input()
  editable = false

  @Output() rate = new EventEmitter<number>()

  rateIndex = 0
  hoverIndex = 0
  @HostListener('mouseleave') onPresenting() {
    this.hoverIndex = this.rateIndex
  }

  constructor() {}

  ngOnInit(): void {}

  getStarClass(v: number): string {
    if (v === 0) {
      return 'far fa-star'
    } else if (v === 1) {
      return 'fas fa-star'
    } else {
      return 'fas fa-star-half-alt'
    }
  }

  onHover(v: number) {
    this.hoverIndex = v
  }

  onVote(v: number) {
    this.rateIndex = v
    this.rate.emit(v)
  }
}
